import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKgAudioFile = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	strokeWidth: 1.5,
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M6 16.079a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0Zm7.5-1.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M16.5 14.579V9a1.5 1.5 0 0 0-1.864-1.455l-4.5.75A1.5 1.5 0 0 0 9 9.75v6.329" }),
		/* @__PURE__ */ _jsx("path", { d: "M22.5 21.75a1.5 1.5 0 0 1-1.5 1.5H3a1.5 1.5 0 0 1-1.5-1.5V2.25A1.5 1.5 0 0 1 3 .75h15a1.5 1.5 0 0 1 1.047.426l3 2.883a1.5 1.5 0 0 1 .453 1.074Z" })
	]
});
export default SvgKgAudioFile;
